import React, { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faPlane, faSuitcase, faTruckMoving } from "@fortawesome/free-solid-svg-icons";


function AirportServices() {
  const [openFAQ, setOpenFAQ] = useState(null);  // To track which FAQ is open

  const airportServices = [
    {
      service: "Passport Service",
      description: "Are you stuck at the airport without your passport? Our passport courier service can collect your forgotten passport within 60 minutes and deliver it directly to you, avoiding delays to your holiday or business trip!",
      icon: <FontAwesomeIcon icon={faPlane} className="w-16 h-16 text-black" />,
    },
    {
      service: "Forgotten Luggage",
      description: "Did you forget that last bag and can't make it back to the airport to pick it up? Don't worry. We can pick up your left luggage from any of our 22 UK mainland airports. Take the stress away and use 1UKLogistics.",
      icon: <FontAwesomeIcon icon={faSuitcase} className="w-16 h-16 text-black" />,
    },
    {
      service: "Airport Same Day",
      description: "Our Airport Same Day courier service ensures delivery of items within the shortest possible time. Just tell us what you require and we'll collect your parcel from your business address and drop it off at any one of our 22 UK airports.",
      icon: <FontAwesomeIcon icon={faTruckMoving} className="w-16 h-16 text-black" />,
    },
  ];
  

  const handleFAQClick = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);  // Toggle open FAQ
  };

  return (
    <div>
      {/* Hero Section */}
      <div
        className="relative bg-cover bg-center h-[400px] md:h-[600px]"
        style={{ backgroundImage: "url('images/aircar1.png')" }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative z-10 flex flex-col items-center justify-center text-center h-full text-white">
          <h1 className="text-4xl md:text-7xl xl:text-8xl font-semibold">Airport Services</h1>
        </div>
      </div>

      {/* Airport Services Section */}
      <section id="airport-services" className="py-16 bg-white text-black">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 justify-items-center">
          {airportServices.map((service, index) => (
            <div key={index} className="flex flex-col gap-6 items-center text-center mt-6 px-3">
              <h3 className="text-2xl font-thin mb-1">{service.service}</h3>
              <div className="mb-2 text-red-500 ">{service.icon}</div>
              <p className="text-zinc-600 max-w-sm font-thin  text-justify">{service.description}</p>
            </div>
          ))}
        </div>
      </section>


      <div className="bg-white text-black md:p-8 flex flex-col md:flex-row gap-8 items-center justify-center">
  {/* left Side: Airport Locations */}
  <div className="">
    <h3 className="text-3xl lg:text-4xl font-thin mb-4 text-center">Our Airports</h3>
    <ul className="grid grid-cols-1 md:grid-cols-2 font-thin xl:grid-cols-3 gap-3 md:gap-5 lg:gap-8 md:text-lg mt-12">
      <li>ABZ - Aberdeen Airport</li>
      <li>BHX - Birmingham Airport</li>
      <li>BRS - Bristol Airport</li>
      <li>CWL - Cardiff Airport</li>
      <li>DSA - Doncaster Sheffield Airport</li>
      <li>EDI - Edinburgh Airport</li>
      <li>EMA - East Midlands Airport</li>
      <li>EXT - Exeter Airport</li>
      <li>GLA - Glasgow Airport</li>
      <li>HUY - Humberside Airport</li>
      <li>LPL - Liverpool Airport</li>
      <li>LBA - Leeds Bradford Airport</li>
      <li>LCY - London City Airport</li>
      <li>LGW - London Gatwick Airport</li>
      <li>LHR - London Heathrow Airport</li>
      <li>LTN - London Luton Airport</li>
      <li>MAN - Manchester Airport</li>
      <li>NCL - Newcastle Airport</li>
      <li>PIK - Prestwick Airport</li>
      <li>SOU - Southampton Airport</li>
      <li>SEN - London Southend Airport</li>
      <li>STN - London Stansted Airport</li>
    </ul>
  </div>

 
</div>
      {/* FAQ Section */}
      <section id="faq" className="px-3 pt-16 xl:p-20 bg-white text-black">
        <div className="flex justify-center">
          <div className=" space-y-8 w-full max-w-5xl">
            <h2 className="text-3xl lg:text-4xl font-thin text-center mb-8">Airport Service FAQ's</h2>
            <div className="space-y-6 ">
              {['What can I do if I have left my passport at home?', 
                'Can you collect my left luggage?', 
                'Do you offer a same day delivery service to all UK airports?', 
                'Can you drop off my suitcase to me at the airport?'].map((question, index) => (
                <div key={index}>
                  <div 
                    className="flex items-center justify-between cursor-pointer font-thin border-b border-black pb-4"
                    onClick={() => handleFAQClick(index)}
                  >
                    <h3 className="text-lg md:text-xl font-thin">{question}</h3>
                    <FontAwesomeIcon icon={faChevronDown} 
                      className={`transition-transform ${openFAQ === index ? 'rotate-180' : ''} text-black`}
                    />
                  </div>
                  {openFAQ === index && (
                    <p className="text-black mt-4 font-thin">
                      {index === 0 && "Don't worry! We offer a Passport Service that can collect your forgotten passport from home and deliver it to you at the airport within 60 minutes. Just contact us, and we'll handle the rest."}
                      {index === 1 && "Yes, we can collect your left luggage from any of the 22 UK mainland airports and deliver it to you at your location. Use our service to take the stress away."}
                      {index === 2 && "Yes, we have access to all 22 UK mainland airports. With a fleet of 3000 drivers, we can guarantee a pickup within 60 minutes and deliver your items to any airport on the same day. Our Airport Same Day service operates 24/7, 365 days a year."}
                      {index === 3 && "Yes, we can drop off your suitcase at any of the 22 UK mainland airports. Just let us know your location, and we'll handle the rest with our efficient delivery service."}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AirportServices;
